import { gql } from '@apollo/client'

export const ACTIVITY_LIST_INITIAL_DATA = gql`
  query GetActivityListInitialData($employeeId: HashedId!, $lastYear: Boolean = false) {
    retrieveActivityListInitialData(employeeId: $employeeId, lastYear: $lastYear) {
      type
      length
      data {
        type
        name
        date
        url
      }
    }
  }
`

export const ACTIVITY_LIST_DATA = gql`
  query GetActivityListData($employeeId: HashedId!, $type: ActivityListType!, $page: Int!, $length: Int!, $lastYear: Boolean = false) {
    retrieveActivityListData(employeeId: $employeeId, type: $type, page: $page, length: $length, lastYear: $lastYear) {
      type
      name
      date
      url
    }
  }
`
